import {
  createContext,
  FunctionComponent,
  ReactElement,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useQuery } from "@tanstack/react-query";

import Api from "src/Config";
import { format } from "date-fns";
// import { textTruncate } from "src/helpers/truncateText";
// import { Box, Text } from "@chakra-ui/react";

export const MyAssignedTransactionContext = createContext(null);

type Props = {
  children: ReactElement;
};

const MyAssignedTransactionProvider: FunctionComponent<Props> = ({
  children,
}) => {
  const [pageNumber, setPageNumber] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["my_assigned_transactions"],
    staleTime: 30000,
    queryFn: async () => {
      const { data } = await Api.get(`tm/transactions/myassigned`);

      const response = data.results.map(
        (res: {
          id: string;
          assignment_date: string;
          user: { first_name: string; last_name: string };
        }) => ({
          id: res.id,
          "transactions assigned":
            `${res.user.first_name} ${res.user.last_name}` || "N/A",
          "date and time of assignment": format(
            new Date(res.assignment_date),
            "dd MMM yyyy, hh:mm a",
          ),
        }),
      );

      return { response, metadata: data?.metadata };
    },
  });

  useEffect(() => {
    if (data) {
      setPageCount(Math.ceil(data?.metadata.count / 10));
    }
  }, [data]);

  const contextValue = useMemo(
    () => ({
      isLoading,
      data,
      error,
      isFetching,
      pageCount,
      pageNumber,
      setPageNumber,
    }),
    [isLoading, data, error, isFetching, pageCount, pageNumber, setPageNumber],
  );
  return (
    <MyAssignedTransactionContext.Provider value={contextValue}>
      {children}
    </MyAssignedTransactionContext.Provider>
  );
};

export default MyAssignedTransactionProvider;
